import React, { useEffect, useRef, useState, useMemo } from "react";
import Header from "src/components/layout/Header";
import SelectSiteHeader from "src/components/layout/SelectSiteHeader";
import { PAT_URL } from "src/shared/config";
import Cookies from "js-cookie";
import { usePlantsListById } from "src/api/userInfo";
import { useDempStore } from "src/context/stores";

const ShippingTransactionList = () => {
  const [companyId, plantId] = useDempStore((state) => [ state.companyId, state.plantId]);
  const { plantsListById } = usePlantsListById(plantId);
  const iframeRef = useRef(null);


  useEffect(() => {
    if (iframeRef.current) {
      iframeRef.current.setAttribute("scrolling", "no");
    }

    const handleIframeMessage = event => {
      if (event.origin !== PAT_URL) return;
      const { height } = event.data;
      if (height && iframeRef.current) {
        iframeRef.current.style.height = `${height}px`;
      }
    };
    window.addEventListener("message", handleIframeMessage);

    return () => {
      window.removeEventListener("message", handleIframeMessage);
    };
  }, []);
  return (
    <section className="relative">
      <Header pageTitle={"Shipment"} showSubMenu={false}>
        <SelectSiteHeader />
      </Header>
      <section className="bg-white size-full">
        <iframe
          // ref={iframeRef}
          src={`${PAT_URL}?role=${plantsListById?.role}&csrfToken=${Cookies.get('csrfToken')}&sessionid=${Cookies.get('sessionid')}&companyId=${companyId}&plantId=${plantId}`}
          className="w-full border-t border-solid h-[calc(100vh-70px)]"
          // className="fixed inset-0 bg-white z-50 w-full h-[calc(100vh-121.82px)]"
          allowFullScreen
        />
      </section>
    </section>
  );
};

export default ShippingTransactionList;
